import { Injectable } from '@angular/core';

export class Customer {
  ID: number;

  image: string;

  numSerie: string;

  fechaHora: string;

  modelo: string;

  descripcion: string;

}

const сustomers: Customer[] = [{
  ID: 1,
  image: './assets/image/garzaimage.jpg',
  numSerie: 'BEPYNSN',
  fechaHora: '01/04/2021 4:44',
  modelo: 'Garza',
  descripcion: 'Este es un demo',
}];

@Injectable()
export class Service {
  getCustomers() {
    return сustomers;
  }
}
